import { useAppSelector } from "@/shared/lib/redux"
import { selectApiKey, selectApiKeyLoading } from "../../model"
import { CopyButton } from "../copy-button"
import notify from "@/shared/lib/notify"
import { API_URL } from "@/shared/api/base"
import { Loader } from "@/shared/ui/loader"
import WarningSvg from "@/shared/assets/images/Warning.svg"
import { RecreateApiKey } from "../recreate-api-key"
import { UpdateApiKey } from "../update-api-key"

export const ApiKey = () => {
    const apiKey = useAppSelector(selectApiKey)
    const apiKeyLoading = useAppSelector(selectApiKeyLoading)

    const handleCopyApiKey = () => {
        navigator.clipboard.writeText(apiKey.token).then(() => notify.success('Скопировано'))
    }

    const handleCopyApiUrl = () => {
        navigator.clipboard.writeText(API_URL).then(() => notify.success('Скопировано'))
    }

    return (
        <div className="box">
            <div className="box_header !mb-2 font-mediumttf">
                API-КЛЮЧ
            </div>
            <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-3">
                    <div className="flex flex-col gap-2">
                        <div className="text-color-secondary uppercase font-bold text-base">
                            API-КЛЮЧ
                        </div>
                        <div className="text-[13px] font-semibold">
                            С помощью API Ключа вы можете получить доступ к внешнему API сервиса
                        </div>
                    </div>
                    <div className="rounded-lg h-[60px] px-2 flex bg-[#FAFAFA] border-[#B9C9C6] items-center w-full border-b">
                        {apiKey && 
                            <div className="justify-between flex w-full items-center">
                                <div className="flex items-center gap-[6px]">
                                    <CopyButton onClick={handleCopyApiKey} />
                                    <div className="font-semibold text-[13px]">
                                        {apiKey.token}
                                    </div>
                                </div>
                                <div className="flex gap-3">
                                    <RecreateApiKey />
                                    <UpdateApiKey />
                                </div>
                            </div>
                        }
                        {(!apiKey && !apiKeyLoading) &&
                            <div className="flex items-center gap-[6px]">
                                <WarningSvg width={24} height={24}/>
                                <div className="font-semibold text-[13px]">
                                    Нет данных о API-Ключе
                                </div>
                            </div>
                        }
                        {(!apiKey && apiKeyLoading) &&
                            <div>
                                <Loader />
                            </div>
                        }
                    </div>
                </div>
                <div className="flex flex-col gap-3">
                    <div className="flex flex-col gap-2">
                        <div className="text-color-secondary uppercase font-bold text-base">
                            Внешний адрес
                        </div>
                    </div>
                    <div className="rounded-lg h-[60px] px-2 flex bg-[#FAFAFA] border-[#B9C9C6] items-center w-full border-b">
                        <div className="justify-between flex items-center">
                            <div className="flex items-center gap-[6px]">
                                <CopyButton onClick={handleCopyApiUrl} />
                                <div className="font-semibold text-[13px]">
                                    {API_URL}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}